import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined'

export const SearchResultVehicleIcon = DirectionsCarFilledOutlinedIcon
export default SearchResultVehicleIcon
